const system = {
	state: {
		// 备案号
		icp: 'Copyright @' + process.env.VUE_APP_TITLE + ' ICP备案号: 宁ICP备2021002175号-3',
		loginSms: '1',
		registSms: '0',
		forgePasswordSms: '1',
		// 学历结构树
		degreeTree: [
			{ label: '大专以下', value: "01" },
			{ label: '大专', value: "02" },
			{ label: '本科', value: "03" },
			{ label: '硕士', value: "04" },
			{ label: '博士', value: "05" },
			{ label: '其它', value: "09" }
		],
		// 学时证明标题
		certHead: '畅度云学·专业技术人员继续教育培训平台',
	},

	// 改变state
	mutations: {

	},

	actions: {

	}
}

export default system